(function () {
  const root = document.querySelector('[data-sticky-bottom-menu]');
  if (!root) return;

  const threshold = Math.max(0, parseInt(root.dataset.scrollThreshold || '120', 10) || 0);
  const designMode = root.dataset.designMode === 'true';

  function openHeaderSearchModal() {
    const modals = Array.from(document.querySelectorAll('details-modal.header__search'));
    if (!modals.length) return;

    const visibleModal =
      modals.find((modal) => {
        const summary = modal.querySelector('summary');
        if (!summary) return false;
        const cs = window.getComputedStyle(summary);
        return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0;
      }) || modals[0];

    if (typeof visibleModal.openFromExternal === 'function') {
      visibleModal.openFromExternal();
    }
  }

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-opens-header-search]');
    if (!trigger) return;
    event.preventDefault();
    openHeaderSearchModal();
  });

  function setVisible(visible) {
    root.classList.toggle('sticky-bottom-menu--visible', visible);
    document.body.classList.toggle('sticky-bottom-menu-visible', visible);
  }

  function onScroll() {
    if (designMode) return;
    setVisible(true);
  }

  if (designMode) {
    setVisible(true);
  } else {
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const current = (root.dataset.currentPath || '').replace(/\/+$/, '') || '/';
  root.querySelectorAll('a[data-sticky-nav-link]').forEach((a) => {
    try {
      const path = new URL(a.getAttribute('href'), window.location.origin).pathname.replace(/\/+$/, '') || '/';
      if (path === current) {
        a.classList.add('sticky-bottom-menu__item--active');
        a.setAttribute('aria-current', 'page');
      }
    } catch (e) {
      /* ignore invalid href */
    }
  });
})();
